const getters = {
  au: state => state.user.au,
  managerInfo: state => state.user.managerInfo,
  naturalInfo: state => state.natural.naturalInfo,
  corporateInfo: state => state.corporate.corporateInfo,
  productInfo: state => state.product.productInfo,
  riskResult: state => state.risk.riskResult,
};

export default getters;
